/**
 * ProblemMechanismsTab — T26.
 * Per-product library editor for the 'problem_mechanism' parameter type.
 */
import LibraryEditor from './LibraryEditor';

interface ProblemMechanismsTabProps {
  canWrite: boolean;
}

export default function ProblemMechanismsTab({ canWrite }: ProblemMechanismsTabProps) {
  return <LibraryEditor type="problem_mechanism" canWrite={canWrite} perProduct />;
}
